

<template>
  <div v-if="feature_hide_ocr_boxes && !feature_force_show_ocr_boxes && !permission.is_readonly">
    <v-btn color="primary" :class="stylev2 ? 'action-btn-doc' : ''" :outlined="!stylev2" :icon="stylev2" fab small v-if="lightbulb_state!='done'" :loading="lightbulb_state=='loading'" @click="show_boxes">
        <v-icon v-if="!stylev2" v-once>mdi-lightbulb</v-icon>
        <AppIcon src="/invoices/lightbulb_circle.svg" :size="24" :preserveColors="true" v-else />
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import {vuexPrefix} from "../store/vuex_utils"

export default {
  name: "ShowBoxesBtn",
  props: {
    stylev2: {
      type: Boolean,
      default:false
    },    
  },
  data() {
    return {
      lightbulb_state: 'showing',
    };
  },
  computed:{
    ...mapGetters('documents',['currentDocument']),
    ...mapGetters({
      permission: 'permissions/permission',
    }),
    ...mapFields('me',vuexPrefix('',[
        'feature_hide_ocr_boxes', 'feature_force_show_ocr_boxes'
    ],'userData.available_features.')),
  },
  methods: {
    ...mapActions('documents',['getTextTagging']),
    async show_boxes() {
      this.lightbulb_state='loading'
      this.getTextTagging()
      this.lightbulb_state='done'
    },
  },
};
</script>
